const initialState = {

    states: {},
  }
  
  const country = (state = initialState, action) => {
    switch (action.type) {
  
      case 'SET_COUNTRY_COUNT_LIST':
        return {
          ...state,
          showCountryDataList: true,
          countryCountSuccess : action.response.success,
          countryCountData : action.response.countryData,
        }
      
        case 'SET_COUNTRY_USERS_LIST':
         return{
          ...state,
          showCountryDataList: false,
          showCountryUsersDataList: true,
          countryUsersSuccess : action.response.success,
          countryUsersData : action.response.usersList,
         }

        case 'SET_DATA_SHOW_COUNTRY_USERS':
         return{
           ...state,
           showCountryDataList: false,
          showCountryUsersDataList: true,
          countryUsersCountData : action.countryData
         }

         case 'SET_DEMOGRAPHICS_DATA_BY_USER':
        return{
          ...state,
          userDemographicsDataSuccess : action.response.success,
          userDemographicsData : action.response.demographicsQuestionAnswer,
        }

        case 'SET_EMPTY_RES_DEMOGRAPHICS_DATA_BY_USER':
        return{
          ...state,
          userDemographicsDataSuccess : null,
          userDemographicsData : null,
        }
  
      default:
        return state;
    }
  };
  export default country;
  


// WEBPACK FOOTER //
// ./src/reducers/country.js